// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3rsz_","insightsList":"newBusinessInsightsMenu_insightsList__2-W0P","active":"newBusinessInsightsMenu_active__24XuT"};